const Services = () => {
  return (
    <div className="service">
      <h2>Layanan yang diberikan <span className="orange_text">ChiFlo</span></h2>
      <div className="service__wrapper">
        <div className="service__item">
          <img src="/service-1.png" alt="icon" />
          <p>Memberikan Informasi Terkait Banjir</p>
        </div>
        <div className="service__item">
          <img src="/service-2.png" alt="icon" />
          <p>Jasa Pembersihan Rumah & Properti</p>
        </div>
        <div className="service__item">
          <img src="/service-3.png" alt="icon" />
          <p>Asuransi Aset & Properti</p>
        </div>
      </div>
    </div>
  )
}

export default Services
